// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"a4d26dec","453":"24854f8e"}[chunkId] + ".chunk.js";
};